import { useAuthStore } from '@/modules/auth/store/auth';
import { storeToRefs } from 'pinia';
import { userType } from '@/constants/UserType';
import { isEmpty } from 'lodash';

export default defineNuxtRouteMiddleware(async (to) => {
  const {
    hasCompletedOnboarding,
    hasPersonalDetails,
    hasLoggedInUser,
    isVerified,
    accountType,
    hasStripePayoutCompleted,
    isPendingApproval,
  } = storeToRefs(useAuthStore());

  if (isEmpty(accountType.value)) {
    return;
  }

  const onboardingSteps = computed(() => {
    // Customer
    if (accountType.value === userType.CUSTOMER) {
      return [
        {
          name: 'register',
          isComplete: hasLoggedInUser.value,
        },
        {
          name: 'verify',
          isComplete: isVerified.value,
        },
        {
          name: 'customer-personal-details',
          isComplete: hasPersonalDetails.value && hasCompletedOnboarding.value,
        }
      ];
    }
    // Merchant
    return [
      {
        name: 'merchant-register',
        isComplete: hasLoggedInUser.value,
      },
      {
        name: 'verify',
        isComplete: isVerified.value,
      },
      {
        name: 'merchant-business-details',
        isComplete: hasCompletedOnboarding.value,
      },
      {
        name: 'merchant-payout',
        isComplete: hasStripePayoutCompleted.value || isPendingApproval.value,
      }
    ];
  });

  const firstIncompleteStep = onboardingSteps.value.find((step) => !step.isComplete);
  const currentStepName = firstIncompleteStep?.name;

  if (to.name !== currentStepName) {
    return navigateTo({ name: currentStepName });
  }
});
